jQuery(document).ready(function($) {
/* ====================== VARIABLE DECLERATION ======================  */
	var lastScrollTop = 0;

/* ====================== TESTIMONIALS CAROUSEL ======================  */
	// $('.masthead__carousel').owlCarousel({
	// 	items: 1,
	// 	loop:true,
	// 	margin:10,
	// 	nav:false,
	// 	dots: true,
	// 	animateOut: 'fadeOut',
	// 	animateIn: 'fadeIn',
	// 	autoplay: true,
	// 	autoplayTimeout:7000,
	// 	autoplaySpeed:750,
	// })

/* ====================== TESTIMONIALS CAROUSEL ======================  */
	$('.testimonials__carousel').owlCarousel({
		items: 1,
		loop:true,
		margin:10,
		nav:false,
		dots: true,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		autoplay: true,
		autoplayTimeout:7000,
		autoplaySpeed:750,
		autoHeight: true,
	})

/* ====================== HOME MASTHEAD SLIDER CAROUSEL ======================  */
	$('.masthead--home .masthead__image').owlCarousel({
		items: 1,
		loop:true,
		margin:0,
		nav:false,
		dots: false,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		autoplay: true,
		autoplaySpeed:750,
		mouseDrag: false,
		touchDrag: false
	})

/* ====================== HEADERS SCROLL FUNCTIONS ======================  */
	$(window).scroll(function(event){
		 var st = $(this).scrollTop();

		 if (st > 20){
		    // $('.header__eyebrow').slideUp();
		    $('.header__main').addClass('header__main--shrink');
		    $('.nav').addClass('nav--shrink');
		 } else {
		    // $('.header__eyebrow').slideDown();
		    $('.header__main').removeClass('header__main--shrink');
		    $('.nav').removeClass('nav--shrink');
		 }

	 	lastScrollTop = st;
	});

/* ====================== SMOOTH SCROLL TO CONTACT ======================  */
	$('.smooth-scroll').on('click', function(event) {
	  var target = $(this.getAttribute('href'));
	  if( target.length ) {
	      event.preventDefault();
	      $('html, body').stop().animate({
	          scrollTop: target.offset().top - 750
	      }, 1000);
	  }
	});


/* ====================== HEADER MENU TOGGLE ======================  */
  $('.menu-toggle').on("click", function() {
    $('nav').toggleClass('open');
    $('.header').toggleClass('header--navopen');
    $('body').toggleClass('nav-open');
    $(this).toggleClass('menu-toggle--open');
  })


/* ====================== NAB SUB MENU TOGGLE ======================  */
  function enableNavItemClicK() {
    if ($(window).width() < 992) {
      $('.nav li.menu-item-has-children').on("click", function(e) {
            $(this).find('a').addClass('active');
            $(this).find('.sub-menu').slideDown();
      })
    } else {
      $('.nav li.menu-item-has-children').each(function(){
        $(this).find('a').removeClass('active');
      })
    }
  }

/* ====================== GALLERY CAROUSEL ======================  */
	var owl = $('.gallery__slider').owlCarousel({
		dots: false,
		margin: 1,
		nav: false,
		loop: true,
		autoplay: true,
		slideBy: 5,
		responsive : {
			0 : {
				items:1
			},
			600 : {
				stagePadding: 50,
				items:2,
			},
			900 : {
				items:3,
			},
			1200 : {
				items:5,
			},
		}
	});


/* ====================== ADD SHRINK HEADER CLASS ======================  */
	function darkenHeader() {
		if ($(window).width() >= 768) {
			$(window).scroll(function(event){
				 var st = $(this).scrollTop();

				 if (st > 150){
				    $('.header__main').addClass('header__main--dark');
				 } else {
				    $('.header__main').removeClass('header__main--dark');
				 }

			 	lastScrollTop = st;
			});
		} else {
			if($('.header__main').hasClass('header__main--dark')) {
				$('.header__main').removeClass('header__main--dark');
			}
		}
	}


/* ====================== SERVICES MODAL ======================  */
  // var inst = $('[data-remodal-id=services]').remodal();

  // $('.service__benefits--list a').on("click", function(e) {
  //   e.preventDefault();
  //   var id = $(this).attr("data-target");
  //   console.log(id);
  //   $('.remodal--services .remodal__content').removeClass('remodal__content--active');
  //   $('.remodal--services .remodal__content[data-target="'+id+'"]').addClass('remodal__content--active');
  //   inst.open();
  // })


/* ====================== GALLERY CAROUSEL ======================  */
	var accredLogos = $('.accreditations__logos').owlCarousel({
		dots: true,
		margin: 20,
		nav: false,
		loop: true,
		autoplay: true,
		responsive : {
			0 : {
				items:1,
				slideBy: 1,
			},
			481 : {
				items:2,
				slideBy: 2,
			},
			550 : {
				items: 3,
				slideBy: 3,
			},
			768: {
				dots: false,
				items: 5,
				slideBy: 5,
			}
		}
	});

	// function accreditationsSlider() {
	// 	if($(window).width() < 768) {
	// 		var accredLogos = $('.accreditations__logos').owlCarousel({
	// 			dots: true,
	// 			margin: 1,
	// 			nav: false,
	// 			loop: true,
	// 			autoplay: true,
	// 			responsive : {
	// 				0 : {
	// 					items:1,
	// 					slideBy: 1,
	// 				},
	// 				481 : {
	// 					items:2,
	// 					slideBy: 2,
	// 				},
	// 				550 : {
	// 					items: 3,
	// 					slideBy: 3,
	// 				}
	// 			}
	// 		});
	// 	} else {
	// 		$('.accreditations__logos').trigger('destroy.owl.carousel').removeClass('owl-loaded');
 //        	$('.accreditations__logos').find('.owl-stage-outer').children().unwrap();
	// 	}
	// }


/* ====================== ISOTOPE CASE STUDIES PORTFOLIO ======================  */
  var $container = $('.case-studies__list');
  var isotopePortfolio = function(filter) {
      $container.isotope({
          itemSelector: '.item',
          layoutMode: 'fitRows',
          filter: filter
      })
  };

  isotopePortfolio('*');

/* ====================== ISOTOPE CASE STUDIES FILTER ======================  */
  $('.case-studies__filter').on( 'click', 'a',  function(e) {
      e.preventDefault();
      $('.case-studies__filter').find('li').removeClass('active');
      $(this).parent('li').addClass('active');

      var selector = $(this).attr('data-filter');
      isotopePortfolio(selector);
  });


	var homeAbout = $('.home .about').waypoint(function(direction) {
		$('.about__bg').toggleClass('about__bg--animate')
	}, {
	  offset: '50%'
	})

/* ====================== Masthead ======================  */
	$('.masthead__scroll').on("click", function(e) {
		e.preventDefault();
		var nextDiv = $(this).parent().next('div')
		 $('html, body').stop().animate({
	          scrollTop: nextDiv.offset().top
	      }, 1000);
	})

/* ====================== Enable functions on page load ======================  */
  enableNavItemClicK();
  darkenHeader();
  // accreditationsSlider();

/* ====================== RESIZE FUNCTION ======================  */
  $(window).resize(function(){
    enableNavItemClicK();
    darkenHeader();
    // accreditationsSlider();
  })


	$(window).bind("load", function() {
	    $('body').addClass('loaded');
  		$('.home .masthead__image').addClass('masthead__image--scaled');
  		new WOW().init();
	});
});
